export const isMCCLevel = scope => !scope || !scope.values || !scope.values.aid;

export function getCurrentCustomerLabels($, edmCampaign) {
  if (!$ || !$.advertiser || !edmCampaign) {
    return undefined;
  }

  const cid = $.advertiser.getUrlParameter('cid');
  const customer = edmCampaign
    .Customers
    .$withKey(cid);

  return customer.Labels;
}

export function getEntitySet(scope, edm, $, edmCampaign) {
  if (isMCCLevel(scope)) {
    return getCurrentCustomerLabels($, edmCampaign);
  }

  return edm && edm.currentAccount ? edm.currentAccount.Labels : undefined;
}
